import { render, staticRenderFns } from "./newsEditComponent.vue?vue&type=template&id=6286f8fa&"
import script from "./newsEditComponent.vue?vue&type=script&lang=ts&"
export * from "./newsEditComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports